import { IIdentificacaoBasica } from '../../../../interfaces/IIdentificacaoBasica';
import InformacaoBasica from '../../../../components/informacaoBasica/informacaoBasica';
import styles from './titularArrendatarioIdBasica.module.scss';
import { BrLoading } from '@govbr-ds/react-components';
import { formatarCNPJOrCpf } from '../../../../utils/formatCNPJOrCPF';
import { formatarCEP } from '../../../../utils/formatCEP';
import { formatarTelefone } from '../../../../utils/formatTelefone';

interface TitularArrendatarioIdBasicaProps {
  declaranteData: IIdentificacaoBasica | undefined;
  isDeclaranteDataLoading: boolean;
  noBorder?: boolean;
  regimeTributarioData?: string;
}

interface IInfo {
  label: string;
  value: string | undefined;
  class?: string;
  format?: Function;
}

function TitularArrendatarioIdBasica({
  declaranteData,
  isDeclaranteDataLoading,
  noBorder = false,
  regimeTributarioData,
}: TitularArrendatarioIdBasicaProps) {
  const CAMPOS_IDENTIDADE: IInfo[] = [
    { label: 'Nome/Razão Social', value: declaranteData?.nomeRazaoSocial },
    {
      label: 'CPF/CNPJ',
      value: declaranteData?.cpfCnpj,
      format: formatarCNPJOrCpf,
    },

    { label: 'Logradouro', value: declaranteData?.logradouro },
    { label: 'CEP', value: declaranteData?.cep, format: formatarCEP },
    {
      label: 'Município/UF',
      value: `${declaranteData?.municipio}/${declaranteData?.uf}`,
    },

    { label: 'E-mail', value: declaranteData?.email },
    {
      label: 'Telefone',
      value: declaranteData?.telefone,
      format: formatarTelefone,
    },
  ];

  if (regimeTributarioData) {
    CAMPOS_IDENTIDADE.push({ label: 'Regime Tributário', value: regimeTributarioData });
  }

  const containerStyle = noBorder ? styles.containerPrincipalNoBorder : styles.containerPrincipal;

  return (
    <div className={containerStyle}>
      <h4 className={styles.title}>Identificação Básica</h4>
      {declaranteData && !isDeclaranteDataLoading ? (
        <div className={styles.containerInterno}>
          {CAMPOS_IDENTIDADE.map((campo, index) => (
            <div key={index} className={campo.class ?? ''}>
              <InformacaoBasica
                titulo={campo.label}
                conteudo={campo.format && campo.value ? campo.format(campo.value) : campo.value || '-'}
              ></InformacaoBasica>
            </div>
          ))}
        </div>
      ) : isDeclaranteDataLoading ? (
        <div className={styles.tableLoading}>
          <BrLoading large label='Carregando...' />
        </div>
      ) : (
        <div className={styles.containerMensagem}>Não foi possível localizar os dados básicos.</div>
      )}
    </div>
  );
}

export default TitularArrendatarioIdBasica;
